export class LostPasswordModel {
    EmailAddress: string;
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/model/LostPasswordModel.ts